export default class FormValidation {
  required(value) {
    return [(v) => !!v || "Please provide your " + value];
  }
}
